import React, { useEffect, useState } from 'react';
import error503 from '../assets/img/error503.svg';
import { Link } from 'react-router-dom';
import { setPageTitle } from '../store/slices/pageTitleSlice';
import { useDispatch } from 'react-redux';

const Error503 = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle('Error | Spire360'));
    }, []);

    return (
        <div className="text-center">
            <img src={error503} className='img-fluid vh-65'/>
            <h1 className='text-secondary'>Oops...</h1>
            <h3 className='text-base'>Unexpected Application Error!</h3>
            <div className='text-light mb-6'>The service you are looking for doesn't exist or another error occurred</div>
            <Link to="/" className='btn btn-secondary px-6 rounded'>
            <span className="material-symbols-outlined fs-16 align-text-top">arrow_back_ios</span>
            Go Back
            </Link>
        </div>
    );
};

export default Error503;
